import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { AuthUser, Funcionalidad } from '../Entities';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  public usuario?: AuthUser;
  menu = new Array<Funcionalidad>();

  constructor() {
    var manu_ = JSON.parse(localStorage.getItem('menu')!);

    if (manu_) {
      this.menu = manu_;
    }

    const aux = localStorage.getItem('authUser');
    if ( aux ) {
      this.usuario = JSON.parse(aux);

    }
  }

  getMenu(): Array<Funcionalidad> {

    if (!this.menu) {
      const menu_stored = <Array<Funcionalidad>>(
        JSON.parse(localStorage.getItem('menu')!)
      );
      if (menu_stored) {
        this.menu = menu_stored;
      }
    }
    return this.menu;
  }
  setMenu(menu: Funcionalidad[]) {

    this.menu = this.validarMenu(menu);
    localStorage.setItem('menu', JSON.stringify(this.menu));
  }

  validarMenu(menu: Funcionalidad[]): Funcionalidad[] {

    let true_menu: Funcionalidad[] = [];
    const funcionalidades = [
      'PCONOC',
      'PCOCRE',
      'PCOECTA',
      'DLODFAC',
      'DCODOCS',
      'DLODCP',
      this.usuario?.proveedores && this.usuario.proveedores.length > 0 && this.usuario.proveedores[0].es_repse == true ? 'PREPSE' : 'xxxxxx'
    ];
    let menuLimpio = this.clearMenu(menu);
    funcionalidades.forEach(funcionalidad => {
      true_menu = [
        ...true_menu,
        ...menuLimpio.filter(func => func.codigo == funcionalidad),
      ];
    });
    return true_menu;
  }

  clearMenu(menu: Funcionalidad[]): Funcionalidad[] {

    const menuLimpio: Funcionalidad[] = [];
    menu.forEach(element => {
      if (menuLimpio.filter(x => x.id == element.id).length == 0) {
        menuLimpio.push(element);
      }
    });
    return menuLimpio;
  }
}
